import React from 'react'
import { useTranslation } from 'react-i18next'

const Title = () => {
  const { t } = useTranslation()

  return <div>{t('shareOfRows')}</div>
}

export default Title
